<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon icon="BellIcon" class="cursor-pointer h-6 w-6" :badge="unreadNotifications.length" />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-1 bg-primary text-white">
        <h3 class="text-white">{{ unreadNotificationsCount }}</h3>
        <p class="opacity-75">{{ notificationWord }}</p>
      </div>

      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-4" :settings="settings" :key="$vs.rtl">
        <ul class="bordered-items">
          <li @click="clickedNotification(notification)" v-for="notification in unreadNotifications" :key="notification.uuid" class="flex justify-between px-2 py-1 flex-col notification cursor-pointer">
            <notification-item :item="notification"></notification-item>
            <!--
            <div class="flex items-start">
              <feather-icon :icon="formatIconName(notification.dropdownIcon)" :class="[`text-${notification.dropdownCategory}`, 'stroke-current h-6 w-6']"></feather-icon>
              <div>
                <span class="font-medium block notification-title" :class="[`text-${notification.dropdownCategory}`]">{{ notification.dropdownTitle }}</span>
                <small class="break-all"><div v-html-safe="notification.message(75)"/></small>
              </div>
            </div>
            <small class="pl-6 text-right whitespace-no-wrap">{{ elapsedTime(notification.sentAt) }}</small>
             -->
          </li>
        </ul>
      </component>

      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-1
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
        <span @click="openAllNotifications">Ver Mais</span>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import NotificationService from '@/services/api/NotificationService'
import NotificationItem from './NotificationItem.vue'

export default {
  components: {
    VuePerfectScrollbar,
    NotificationItem
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60,
        service: null
      }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    unreadNotifications () { return this.$store.getters.unreadNotifications },
    unreadNotificationsCount() {
      const len = this.unreadNotifications.length
      return ((len > 0) ?
        ((len > 1) ? `${len} Novas` : '1 Nova') :
        'Nenhuma'
      )
    },
    notificationWord() {
      const len = this.unreadNotifications.length
      return (len > 1) ? 'Notificações' : 'Notificação'
    }
  },
  methods: {
    openAllNotifications() {
      if (this.$route.path !== '/notifications') {
        this.$router.push('/notifications').catch(err => {
          // Ignora erro de navegação duplicada
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      }
    },
    clickedNotification(notification) {
      notification.onClick(this.service, notification)
    },
    formatIconName(notification) {
      try {
        if (!notification || !notification.dropdownIcon) {
          console.warn('Notification missing dropdownIcon:', notification)
          return 'BellIcon'
        }
        let icon = notification.dropdownIcon
        icon = (typeof icon === 'function') ? icon(notification) : icon

        if (!this.$utils || !this.$utils.format || !this.$utils.format.featherIcon || !this.$utils.format.featherIcon.fromNotify) {
          console.error('VueUtils not properly initialized', this.$utils)
          return 'BellIcon'
        }

        return this.$utils.format.featherIcon.fromNotify(icon)
      } catch (error) {
        console.error('Error formatting icon name:', error, notification)
        return 'BellIcon'
      }
    },
    elapsedTime (startTime) {
      const x        = new Date(startTime)
      const now      = new Date()
      let timeDiff = now - x
      timeDiff    /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      const hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      const days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      const years   = timeDiff

      if (years > 0) {
        return `${years + (years > 1 ? ' anos ' : ' Ano ')}atrás`
      } else if (days > 0) {
        return `${days + (days > 1 ? ' dias ' : ' dia ')}atrás`
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' hrs ' : ' hora ')}atrás`
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' mins ' : ' min ')}atrás`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? 's atrás' : 'agora')
      }

      return 'Just Now'
    },
    // Method for creating dummy notification time
    randomDate ({ hr, min, sec }) {
      const date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    },
    openNotificationLink(notification) {
      notification.onClick(this.service)(notification)
    }
  },
  mounted() {
    this.service = NotificationService.build(this)
    const userId = this.$store.getters.userId
    if ('Echo' in window) {
      window.Echo.private(`App.Models.User.${userId}`).notification(
        (notification) => {
          this.service.handleIncomingNotification(notification)
        }
      )
    }
  }
}

</script>

